import axios from "axios";
import ETHValidator from "./ethereum_validator";

function isValidDydxAddress(address) {
  const dydxValidatorURL = `https://api.dydx.exchange/v3/users/exists?ethereumAddress=${address}`;

  return axios
    .get(dydxValidatorURL)
    .then((data) => {
      return data.data.exists;
    })
    .catch((error) => {
      console.error("Invalid dYdX address");
      return false;
    });
}

export default {
  isValidAddress(address) {
    if (address.length !== 42) {
      return false;
    }

    return (
      isValidDydxAddress(address) &&
      ETHValidator.isValidAddress(address, {
        name: "Ethereum",
        symbol: "eth",
      })
    );
  },
};
